import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import SearchForm from "./SearchForm";
import Forecast from "./Forecast";

export default function Weather() {
  const [weather, setWeather] = useState(null);
  const apiKey = "c56dcb7t88aa43c2b2f5cfa690a8917o";

  function handleResponse(response) {
    setWeather({
      city: response.data.city,
      country: response.data.country,
      temperature: Math.round(response.data.temperature.current),
      humidity: response.data.temperature.humidity,
      wind: Math.round(response.data.wind.speed),
      description: response.data.condition.description,
      icon: response.data.condition.icon_url,
      date: new Date(response.data.time * 1000),
    });
  }

  const search = useCallback(
    function (city) {
      const apiUrl = `https://api.shecodes.io/weather/v1/current?query=${city}&key=${apiKey}&units=metric`;
      axios.get(apiUrl).then(handleResponse);
    },
    [apiKey]
  );

  useEffect(() => {
    search("Aveiro");
  }, [search]);

  function formatDate(date) {
    const days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];

    let hours = date.getHours();
    let minutes = date.getMinutes();
    if (minutes < 10) minutes = `0${minutes}`;

    return `${days[date.getDay()]} ${hours}:${minutes}`;
  }

  return (
    <div>
      <header>
        <SearchForm onSearch={search} />
      </header>

      {weather && (
        <main>
          <div className="weather-app-data">
            <div>
              <h1 className="weather-app-city">{weather.city}</h1>
              <span>{weather.country}</span>
              <p className="weather-app-info">
                {formatDate(weather.date)}, {weather.description}
                <br />
                Humidity: <strong>{weather.humidity}%</strong>, Wind:{" "}
                <strong>{weather.wind} km/h</strong>
              </p>
            </div>

            <div className="weather-app-temp-container">
              <div className="weather-app-icon">
                <img src={weather.icon} alt={weather.description} />
              </div>
              <div className="weather-app-temp">{weather.temperature}</div>
              <div className="weather-app-unit">ºC</div>
            </div>
          </div>

          <Forecast city={weather.city} />
        </main>
      )}
    </div>
  );
}
